import { useOutletContext } from "react-router";

import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import Box from "ds/components/Box";
import useTitle from "hooks/useTitle";
import { VcsIntegration } from "types/generated";
import { IntegrationsOutletContext } from "views/Account/Integrations/types";

import VCSIntegrationTroubleshootingIssues from "./Issues";
import VCSIntegrationTroubleshootingStatusCheck from "./StatusCheck";

type VCSIntegrationTroubleshootingProps = {
  integration: VcsIntegration;
};

const VCSIntegrationTroubleshooting = ({ integration }: VCSIntegrationTroubleshootingProps) => {
  const { integration: integrationDetails } = useOutletContext<IntegrationsOutletContext>();

  useTitle(integration?.name ? `Troubleshooting · ${integration.name} · ` : "Troubleshooting");
  useBreadcrumbs(
    [
      {
        title: "Integrations",
        link: "/integrations",
      },
      {
        title: integrationDetails.name,
        link: `/integrations/${integrationDetails.id}`,
      },
      {
        title: integration?.name || "",
      },
    ],
    [integration?.name]
  );

  return (
    <Box direction="row" fullHeight>
      <VCSIntegrationTroubleshootingStatusCheck integration={integration} />
      <VCSIntegrationTroubleshootingIssues />
    </Box>
  );
};

export default VCSIntegrationTroubleshooting;
